import React from "react";
import NavBar from "../../../components/common/navbar";
import SideBar from "../../../components/modules/left_sidebar";
import { withRouter } from "react-router-dom";
import $ from "jquery";
import SelosEmcobranca from "./SelosEmcobranca";
import Footer from '../../../components/common/Footer'
const Administration = false;

/* Array de configurações estáticas da página*/
const optionMenuArray = {
    linkData: {
        filters: {
            Tabs: {
                Entidade: [
                    // {
                    //     key: "nif",
                    //     displayKey: "NIF de entidade",
                    //     inputType: "text",
                    // },
                    {
                        key: "numero",
                        displayKey: "Número de entidade",
                        inputType: "text",
                    },
                    {
                        key: "nome",
                        displayKey: "Nome de entidade",
                        inputType: "text",
                    },
                ],
                Período: [
                    {
                        key: "RangePicker",
                        displayKey: "Data de pedido",
                        inputType: "RangePicker",
                    },
                ],
            },
            checkbox: [],
        },
        navbarOptionsYear: false,
        tableName: "RotulosPendentes",
        TitleBartitle: "Pedidos de avaliação pendentes",
        prevPageName: "",
        prevPageLink: "",
        currentPath: "selos_pedidos",
        TitleBarlogo: "selos",
    },
};

class SelosRastreabilidade extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = this.setLinkDataMethod();
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        $(window).scrollTop(0);
        this.setState(this.setLinkDataMethod());
    };

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (prevProps) => {
        const parsed =
            (this.props.location.state &&
                this.props.location.state.paramoption) ||
            {};
        let prevParsed =
            (prevProps.location.state &&
                prevProps.location.state.paramoption) ||
            {};
        if (
            prevParsed.name !== parsed.name &&
            (!parsed.tableName ||
                parsed.back ||
                this.state.search !== window.location.search ||
                this.state.tableName !== parsed.tableName)
        ) {
            this.setState(this.setLinkDataMethod());
        }
    };
    /*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */
    setLinkDataMethod = () => {
        let parsed =
            (this.props.location.state &&
                this.props.location.state.paramoption) ||
            {};
            //console.log("666777 parsed", parsed)
        if (
            Object.keys(parsed).length === 0 &&
            this.state &&
            this.state.parsed
        ) {
            parsed = this.state.parsed;
        }
        if (parsed.back) {
            parsed = {};
        }
        let topBarMenu =
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.topBarMenu;
        if (topBarMenu) {
            this.setState({ topBarMenu });
        }
        if (parsed) {
            this.setState({ parsed });
        }
        let selectOption = { ...optionMenuArray };
        let linkData = selectOption.linkData;
        if (!parsed.name) {
            linkData.prevPageName = "";
            linkData.prevPageLink = "";
            linkData.tableName = "SelosPendentes";
        }
        // let capitalizeParsedName =
        //     parsed.name === "Pedidos"
        //         ? "pendentes"
        //         : parsed.name
        //         ? parsed.name[0].toLowerCase() + parsed.name.substr(1)
        //         : parsed.name;
        parsed.name = parsed.name ? parsed.name : "";
        parsed.url = parsed.url ? parsed.url : "";
        parsed.tableName = parsed.tableName ? parsed.tableName : "";
        if (parsed.name) {
            linkData.prevPageName = "Rastreabilidade";
            linkData.prevPageLink = parsed.url;
            linkData.tableName = parsed.tableName;
            linkData.TitleBartitle = "Rastreabilidade";
        } else {
            linkData.TitleBartitle = "Rastreabilidade";
        }

        return {
            noOption: true,
            popUpForm: null,
            linkData: linkData,
            pageOption: "",
            Tab: null,
            parsed: parsed,
            tableName: linkData.tableName,
            search: window.location.search,
            topBarMenu: topBarMenu,
        };
    };

    /* Sempre que o usuário alterar qualquer opção do front end, este método irá atualizar o url da página de acordo com essa opção  */

    changeOption = (prevPageName, prevPageLink) => {
        let linkData = { ...this.state.linkData };
        linkData.prevPageName = prevPageName;
        linkData.prevPageLink = prevPageLink;
        // console.log("OKOK");
        this.setState({
            linkData,
        });
    };

    /*  Para renderizar o conteúdo html da página   */

    render() {
        //console.log("Render again",this.props)
        let topBarMenu =
            (this.props.location &&
                this.props.location.state &&
                this.props.location.state.topBarMenu) ||
            this.state.topBarMenu;
        //console.log("topBarMenu", topBarMenu);
        return (
            <div className="dashboard">
                <NavBar
                    date={new Date()}
                    linkData={this.state.linkData}
                    topBarMenuOption={topBarMenu}
                    noOption={this.state.noOption}
                    moduleName="Selos"
                    updateNavDropdown={(_row) => this.updateNavDropdown(_row)}
                />
                <SideBar Administration={Administration} />
                <div className="container-fluid">
                    <SelosEmcobranca
                        date={new Date()}
                        parsed={this.state.parsed}
                        topBarMenuOption={topBarMenu}
                        changeOption={(mainIndex, subIndex) =>
                            this.changeOption(mainIndex, subIndex)
                        }
                        menu={"pedidos"}
                        submenu={"pending"}
                        optionMenuArray={optionMenuArray}
                        linkData={this.state.linkData}
                        trans_methods={this.state.trans_methods}
                        tab={"selos_pendentes"}
                    />
                </div>
                <Footer/>
            </div>
        );
    }
}

export default withRouter(SelosRastreabilidade);
